import { render, staticRenderFns } from "./PaperPreview.vue?vue&type=template&id=f0b58fe2&scoped=true&"
import script from "./PaperPreview.vue?vue&type=script&lang=js&"
export * from "./PaperPreview.vue?vue&type=script&lang=js&"
import style0 from "./PaperPreview.vue?vue&type=style&index=0&id=f0b58fe2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0b58fe2",
  null
  
)

export default component.exports